module.exports = __webpack_public_path__ + "static/dragon_slayer-ecccc2885154e8ce7d0ef62663785355.jpeg";